export default __webpack_public_path__ + "static/media/mode-61.cf328e22.svg";